export default __webpack_public_path__ + "static/flowwow-30776d7513f4c6b4ffc6daf2bfec88a5.png";